import styled, { css } from "styled-components";

import { BoxSizingStyle } from "../BoxSizingStyle";

const StyledMultiAvatarImg = css`
  width: inherit;
  height: inherit;
`;

export const StyledMultiAvatarInner = styled.div`
  overflow: hidden;
  position: absolute;
  display: inline-flex;
`;

export const StyledMultiAvatar = styled.div<{ $urlCount: number }>`
  ${BoxSizingStyle}

  border-radius: 100%;
  position: relative;
  overflow: hidden;

  ${(props) =>
    props.$urlCount === 2 &&
    css`
      ${StyledMultiAvatarInner}:first-child {
        left: 0;
        img {
          transform: translateX(-20%);
        }
      }
      ${StyledMultiAvatarInner}:last-child {
        right: 0;
        img {
          transform: translateX(-20%);
        }
      }
    `}

  ${(props) =>
    props.$urlCount === 3 &&
    css`
      ${StyledMultiAvatarInner}:nth-child(1) {
        left: 0;
        img {
          transform: translateX(-20%);
        }
      }
      ${StyledMultiAvatarInner}:nth-child(2) {
        right: 0;
        top: 0;

        img {
          ${StyledMultiAvatarImg}
        }
      }
      ${StyledMultiAvatarInner}:nth-child(3) {
        right: 0;
        bottom: 0;

        img {
          ${StyledMultiAvatarImg}
        }
      }
    `}

  ${(props) =>
    props.$urlCount > 3 &&
    css`
      img {
        ${StyledMultiAvatarImg}
      }
      ${StyledMultiAvatarInner}:nth-child(1) {
        left: 0;
      }
      ${StyledMultiAvatarInner}:nth-child(2) {
        left: 0;
        bottom: 0;
      }
      ${StyledMultiAvatarInner}:nth-child(3) {
        right: 0;
        top: 0;
      }
      ${StyledMultiAvatarInner}:nth-child(4) {
        right: 0;
        bottom: 0;
      }
    `}
`;

StyledMultiAvatar.displayName = "StyledMultiAvatar";
StyledMultiAvatarInner.displayName = "StyledMultiAvatarInner";
